(() => {
  if (customElements.get('product-custom-size')) return;

  class ProductCustomSize extends HTMLElement {
    connectedCallback() {
      this.sizeOptionName = this.dataset.sizeOption || 'Size';
      this.customSizeValue = (this.dataset.customSizeValue || 'Custom Size').toLowerCase();
      this.formId = this.dataset.formId;
      this.errorMessage = this.dataset.errorMessage || '';
      this.errorEl = this.querySelector('[data-custom-size-error]');
      this.inputs = () => this.querySelectorAll('[data-custom-size-input]');

      this.onDocumentChange = this.onDocumentChange.bind(this);
      this.onSubmitCapture = this.onSubmitCapture.bind(this);

      document.addEventListener('change', this.onDocumentChange);
      this.bindFormSubmit();
      this.toggle(this.isCustomSizeSelected());

      const content = this.closest('.product__content') || document;
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (
              node.nodeType === 1 &&
              (node.matches?.('product-selector') || node.querySelector?.('product-selector'))
            ) {
              this.toggle(this.isCustomSizeSelected());
              return;
            }
          }
        }
      });
      this.observer.observe(content, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onDocumentChange);
      this.unbindFormSubmit();
      this.observer?.disconnect();
    }

    bindFormSubmit() {
      this.form = this.formId ? document.getElementById(this.formId) : null;
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmitCapture, true);
    }

    unbindFormSubmit() {
      if (!this.form) return;
      this.form.removeEventListener('submit', this.onSubmitCapture, true);
    }

    onDocumentChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.closest('product-selector')) return;
      this.toggle(this.isCustomSizeSelected());
    }

    getSizeOptionInputs() {
      const selector = document.querySelector('product-selector');
      if (!selector) return [];

      const escapedName = this.sizeOptionName.replace(/"/g, '\\"');
      return Array.from(
        selector.querySelectorAll(
          `input[type="radio"][name="options[${escapedName}]"], select[name="options[${escapedName}]"]`
        )
      );
    }

    isCustomSizeSelected() {
      const inputs = this.getSizeOptionInputs();
      for (const input of inputs) {
        if (input instanceof HTMLSelectElement) {
          if ((input.value || '').trim().toLowerCase() === this.customSizeValue) return true;
          continue;
        }
        if (input.checked && (input.value || '').trim().toLowerCase() === this.customSizeValue) {
          return true;
        }
      }
      return false;
    }

    toggle(show) {
      this.classList.toggle('hidden', !show);
      this.inputs().forEach((input) => {
        input.disabled = !show;
        if (show) {
          input.setAttribute('required', 'required');
        } else {
          input.removeAttribute('required');
        }
      });
      if (!show) this.clearError();
    }

    validate() {
      if (this.classList.contains('hidden')) return true;

      let valid = true;
      this.inputs().forEach((input) => {
        const empty = !(input.value || '').trim();
        input.closest('.field')?.classList.toggle('has-error', empty);
        if (empty) valid = false;
      });

      if (!valid) {
        this.showError(this.errorMessage);
      } else {
        this.clearError();
      }
      return valid;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.classList.toggle('hidden', !message);
    }

    clearError() {
      this.showError('');
      this.inputs().forEach((input) => {
        input.closest('.field')?.classList.remove('has-error');
      });
    }

    onSubmitCapture(event) {
      if (!this.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('[data-custom-size-input]:not(:disabled)')?.focus();
      }
    }
  }

  customElements.define('product-custom-size', ProductCustomSize);
})();
